import { useParams, useNavigate } from 'react-router-dom';
import { Card, Spin } from '@/shared/ui/primitives';
import { useTranslation } from 'react-i18next';
import PageHeader from '@/shared/components/PageHeader';
import UserForm from '../components/UserForm';
import { useUserDetails } from '../hooks/useUserDetails';
import { useUpdateUser } from '../hooks/useUserMutations';

export default function UserEditPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { data, isLoading: loadingDetails } = useUserDetails(id);
  const mutation = useUpdateUser();

  const handleSubmit = (formData: any) => {
    (mutation.mutate as any)({ id, data: formData }, { onSuccess: () => navigate('/users') });
  };

  if (loadingDetails) return <Spin style={{ display: 'block', margin: '80px auto' }} />;

  return (
    <div>
      <PageHeader back title={t('users.editTitle')} subtitle={`${t('common.editing')}: ${data?.firstName || ''} ${data?.lastName || ''}`} />
      <Card>
        <UserForm initialData={data} onSubmit={handleSubmit} isLoading={mutation.isPending} />
      </Card>
    </div>
  );
}
